import CarouselComicList from "./CarouselComicList"
import ComicList from "./ComicList"

export { CarouselComicList, ComicList }
